class ClickTarget {
	constructor($el) {
        this.$el = $el;

		this.$el.on('mouseenter', this.mouseEnterHandler);
		this.$el.on('mouseleave', this.mouseLeaveHandler);
		this.text =
			this.$el.data('click-target') != undefined
				? this.$el.data('click-target')
				: '';
	}

	mouseEnterHandler = () => {
		window._cursor.show(this.text);
	};

	mouseLeaveHandler = () => {
		window._cursor.hide();
	};
}

export default ClickTarget;